export default __webpack_public_path__ + "static/media/project_etc_on.498ef8b9.svg";